import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class TVLayout extends Component {
  componentDidMount() {
    const {title} = this.props;
    document.title = `MAM: ${title}`;
    document.body.className += ' status-dashboard-layout';
  }

  render() {
    const {className} = this.props;
    return (
      <div className={className}>
        <TVLayoutStyled>
          {this.props.children}
        </TVLayoutStyled>
      </div>
    );
  }
}

const TVLayoutStyled = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

TVLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  className: PropTypes.string
};

export default TVLayout;
